import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  successfulLabelTitle: {
    description: 'returns.returnLabelSuccessTitle',
    defaultMessage: 'Email Sent',
    id: 'QlELZz',
  },
  labelsProcessedSuccessfully: {
    description: 'returns.returnLabelEmailSuccessful',
    defaultMessage: 'Return labels emailed successfully',
    id: 'uIF87L',
  },
  failedLabelTitle: {
    description: 'returns.returnLabelFailedTitle',
    defaultMessage: 'One or more emails failed to send',
    id: 'BRoAUA',
  },
  voidSuccessful: {
    description: 'returns.returnVoidSuccessful',
    defaultMessage: 'Return Voided Successfully',
    id: 'bdSTZ8',
  },
  voidFailure: {
    description: 'returns.returnVoidFailure',
    defaultMessage: 'Return Voided Unsuccessfully',
    id: 'QYxoji',
  },
  cancelReturnTitle: {
    description: 'returns.cancelReturnTitle',
    defaultMessage: 'Cancel Return',
    id: 'hkqd3J',
  },
  cancelReturnContent: {
    description: 'returns.cancelReturnContent',
    defaultMessage:
      'Active labels will be submitted to be voided and the shipments will be cancelled. This only affects ShipStation, further action may need to be taken in your online marketplace.',
    id: '8CESIR',
  },
  cancelReturnConfirmation: {
    description: 'returns.cancelReturnConfirmation',
    defaultMessage: 'Would you like to continue?',
    id: 'ms3S0c',
  },
  returnsExportCompleteTitle: {
    description: 'Title for returns export complete notification',
    defaultMessage: 'Returns Export Ready for Download',
    id: 'KA40G0',
  },
  returnsExportCompleteBody: {
    description: 'Body for returns export complete toast notification',
    defaultMessage: 'Your returns export is ready. A download should have started automatically.',
    id: 'ENovpg',
  },
  searchTermTooShort: {
    description: 'returns.searchTermTooShort',
    defaultMessage: 'Search term should be at least 3 characters long',
    id: 'mjIiX8',
  },
});
